import Vue from 'vue'


const components = {
    'DropdownMenu': () => import('@/components/DropdownMenu')
}

Object.entries(components).forEach(([name, component]) => Vue.component(name, component))